import { render } from "./VoucherBazar.vue?vue&type=template&id=663c843a"
import script from "./VoucherBazar.vue?vue&type=script&lang=js"
export * from "./VoucherBazar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__